"use strict";
/* globals module */
/**
 * @module blogPostFilesBatchClient
 * @description  Blog Post Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var BlogPostFilesBatchClient = /** @class */ (function () {
    function BlogPostFilesBatchClient(blogPostFilesBatchRoute, apiClient) {
        this.blogPostFilesBatchRoute = blogPostFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(BlogPostFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.blogPostFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of article files that needs to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   blogPostFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   blogPostFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    BlogPostFilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.blogPostFilesBatchRoute.unlink(), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of article files objects used to update specified article files.
     * @returns A promise that is resolved once the update action has been performed.
     * @example blogPostFilesBatchClient.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    BlogPostFilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of article file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example blogPostFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    BlogPostFilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    BlogPostFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostFilesBatchRoute !== "undefined" && _1.BlogPostFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostFilesBatchClient);
    return BlogPostFilesBatchClient;
}());
exports.BlogPostFilesBatchClient = BlogPostFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/
